import {IRowNode} from 'ag-grid-community';

import {useCallback} from 'react';

import {GridApi} from '../types/AgGridTypes';
import {DefinitionResponseBody} from '../types/Api';

type UseRowSelectionReturnType = (node: IRowNode, selected: boolean) => void;

export const useRowSelection = (
  api: GridApi | undefined,
  rowSelection: DefinitionResponseBody['behavior']['rowSelectMode']
): UseRowSelectionReturnType =>
  useCallback(
    (node, selected) => {
      if (!api || !rowSelection || api.isDestroyed()) {
        return;
      }

      node.setSelected(selected, rowSelection === 'SINGLE');
      api.refreshCells({
        force: true,
        suppressFlash: true,
        columns: ['eag-col-select'],
      });

      if (rowSelection === 'MULTIPLE') {
        try {
          api.refreshHeader();
        } catch (error) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('refreshHeader failed - column groups may not be initialized yet:', error);
          }
        }
      }
    },
    [api, rowSelection]
  );
